import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import EmptyState from '../../components/common/EmptyState/EmptyState';
import Icon from '../../components/common/Icon/Icon';
import PageContainer from '../../components/common/PageContainer/PageContainer';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import SearchFilterBar from '../../components/common/SearchFilterBar/SearchFilterBar';
import { useBreadcrumbs } from '../../contexts/BreadcrumbContext';
import { searchHelpDocuments } from './helpDocuments';
import styles from './Help.module.css';

const Help: React.FC = () => {
  const { setBreadcrumbs } = useBreadcrumbs();
  const [search, setSearch] = useState('');
  const documents = useMemo(() => searchHelpDocuments(search), [search]);

  useEffect(() => {
    setBreadcrumbs([{ label: 'Ajuda', path: '/ajuda' }]);
    return () => setBreadcrumbs([]);
  }, [setBreadcrumbs]);

  return (
    <PageContainer className={styles.page}>
      <PageHeader
        title="Ajuda"
        subtitle="Pesquise a documentação de como cada parte do sistema funciona"
      />

      <SearchFilterBar
        searchValue={search}
        onSearchChange={setSearch}
        searchPlaceholder="Pesquisar documentação"
      />

      {documents.length === 0 ? (
        <EmptyState message="Nenhuma documentação encontrada com essa busca." />
      ) : (
        <div className={styles.results}>
          {documents.map((document) => (
            <Link key={document.id} to={`/ajuda/${document.id}`} className={styles.linkCard}>
              <span className={styles.iconWrap} aria-hidden="true">
                <Icon name={document.icon} size={22} />
              </span>
              <span className={styles.linkBody}>
                <span className={styles.linkTitle}>{document.title}</span>
                <span className={styles.linkDescription}>{document.description}</span>
              </span>
              <span className={`material-symbols-outlined ${styles.chevron}`} aria-hidden="true">
                chevron_right
              </span>
            </Link>
          ))}
        </div>
      )}
    </PageContainer>
  );
};

export default Help;
